import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";


export const SimuladorIncentivosJefeTallerORSE = ({ rango = null, sueldo = 0, setHoras, setPorcEficiencia, ocultar = false }) => {

    const [state, setState] = useState({
        horasTrabajadas: 0,
        horasTotales: 0,
        // porcentajeTecnicos: 0,
        cumplimiento: 0,
        porcentaje: 0,
        incentivo: 0,
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };
    useEffect(() => {
        if (Number(state.horasTotales !== 0) && Number(state.horasTrabajadas !== 0)) {
            const cumplimiento = truncar((Number(state.horasTrabajadas) / Number(state.horasTotales)) * 100);
            var porcentaje = 0;
            var incentivo = 0;
            if (rango !== null) {
                rango.forEach((index) => {
                    if (index.minimo <= cumplimiento && index.maximo >= cumplimiento) {
                        porcentaje = index.porcentaje;
                        incentivo =
                            Number(sueldo) * index.porcentaje;
                    }
                });
            }


            setState({
                ...state,
                cumplimiento,
                porcentaje: porcentaje * 100,
                incentivo,
            });
        }
    }, [state.horasTrabajadas, state.horasTotales, sueldo, rango]);

    // useEffect(() => {

    //     const porcentajeTecnicos = (Number(tecnicosMas150) / Number(totalTecnicos)) * 100;

    //     setState({
    //         ...state,
    //         porcentajeTecnicos: porcentajeTecnicos,
    //     });
    // }, [tecnicosMas150, totalTecnicos]);
    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Objetivo de Venta</div>
                    <SimuladorNumericInput
                        name="horasTrabajadas"
                        label=""
                        value={state.horasTrabajadas}
                        disabled={false}
                        onChange={handleChange}
                        icono="numero"
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Objetivo Real</div>
                    <SimuladorNumericInput
                        name="horasTotales"
                        label=""
                        value={state.horasTotales}
                        disabled={false}
                        onChange={handleChange}
                        icono="numero"
                    />
                </div>
            </div>
            {/* <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Tecnicos con mas de 150 horas</div>
                    <SimuladorNumericInput
                        name="tecnicosMas150"
                        label=""
                        value={tecnicosMas150}
                        disabled={false}
                        onChange={handleChangeDatos}
                        icono="numero"
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Total técnicos</div>
                    <SimuladorNumericInput
                        name="totalTecnicos"
                        value={totalTecnicos}
                        onChange={handleChangeDatos}
                        disabled={false}
                        icono="numero"
                    />
                </div>
            </div> */}

            {ocultar === true ? (
                <div className="input-container-one">
                    <div className="input-section">
                        <div className="input-title-label">% Eficiencia</div>
                        <SimuladorNumericInput
                            name="cumplimiento"
                            label=""
                            value={state.cumplimiento}
                            disabled={true}
                            align="centro"
                            icono="porcentaje"
                        />
                    </div>
                </div>
            ) : (

                <div className="input-container-duo">
                    <div className="input-section">
                        <div className="input-title-label">% Eficiencia</div>
                        <SimuladorNumericInput
                            name="cumplimiento"
                            label=""
                            value={state.cumplimiento}
                            disabled={true}
                            align="centro"
                            icono="porcentaje"
                        />
                    </div>

                    <div className="input-section">
                        <div className="input-title-label">% de incentivo</div>
                        <SimuladorNumericInput
                            name="porcentajeTecnicos"
                            label=""
                            value={state.porcentaje}
                            disabled={true}
                            align="centro"
                            icono="porcentaje"
                        />
                    </div>
                </div>
            )}

            {ocultar === false && (
                <div className="input-container-one">
                    <div className="input-section">
                        <div className="input-title-label-incentive">Tu incentivo es de:</div>
                        <SimuladorNumericInput
                            name="incentivo"
                            label=""
                            value={state.incentivo}
                            disabled={true}
                            icono="pesos"
                            inputTotal="si"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
